export const useClearLocalStorage = () => {
  const clearLocalStorage = (key: string) => {
    localStorage.removeItem(key);
  };

  return {
    clearLocalStorage,
  };
};
